module.exports = __webpack_public_path__ + "static/img/img_applet_jxs.b971afa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_applet_jxs.jpg
// module id = uUF6
// module chunks = 1